import { Link } from 'react-router-dom';
import { SyncStatus } from '@/components/SyncStatus';

interface AppHeaderProps {
  title: string;
  subtitle?: string;
  /** Hidden while recording so nothing competes with the counting controls. */
  showHistoryLink?: boolean;
}

export function AppHeader({ title, subtitle, showHistoryLink = true }: AppHeaderProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-slate-200 bg-white pt-safe">
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <div className="min-w-0">
          <h1 className="truncate text-lg font-bold text-slate-900">{title}</h1>
          {subtitle ? <p className="truncate text-sm text-slate-500">{subtitle}</p> : null}
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <SyncStatus />
          {showHistoryLink ? (
            <Link
              to="/history"
              className="rounded-lg px-2 py-1 text-sm font-semibold text-brand-700 hover:bg-brand-50"
            >
              History
            </Link>
          ) : null}
        </div>
      </div>
    </header>
  );
}
